(function() {
  'use strict';
  
  function setupHoverEvents() {
    const targetUls = document.querySelectorAll('ul.list-menu.list-menu--inline');
    
    targetUls.forEach(function(ul) {
      let hoverTimeout;
      
      ul.addEventListener('mouseenter', function() {
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(function() {
          if (!ul.classList.contains('active')) {
            ul.classList.add('active');
          }
        }, 250);
      });
      
      ul.addEventListener('mouseleave', function() {
        clearTimeout(hoverTimeout);
                if (ul.classList.contains('active')) {
          ul.classList.remove('active');
        }
      });
    });
  }
function init() {
    setupHoverEvents();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  document.addEventListener('shopify:section:load', function() {
    setTimeout(init, 100);
  });
})();